
import * as THREE from 'node_modules/three/build/three.module.js';
import { Vector3 } from 'three';
import { BoothItem, FBX } from '../models';
import {
    StateService
} from 'src/app/services';
import { TweenMax } from 'gsap';
import boothData from '../data/booths.json';

export class Booth {
    public degRad: number = 0.0174532925;
    public _fbx: FBX = undefined;
    public myBooth: BoothItem = undefined;
    public scale: any = { x: 4, y: 4, z: 4 };
    public _parent: any = undefined;
    public bVisible: any = undefined;
    public navIcons: Array<any> = [];  // These are the brand nav arrows.
    public textHovers: Array<any> = [];
    public clickables: Array<any> = [];

    public mainDisplayMesh: any = undefined;
    public blurMat: any = undefined;
    public normalMat: any = undefined;
    public blurLoaded: boolean = false;

    public tweens: Array<any> = [];
    constructor(
        public fbx: FBX, private parentRef: any, private stateSvc: StateService) {
        this._fbx = fbx;
        this._parent = parentRef
    }

    public handleStateChange(nState: any): void {
        if (nState === this.myBooth.id) {
            this.aniNav();
        } else {
            this.aniNav(false);
        }
    }


    public aniNav(bIn: Boolean = true): void {
        let small: any = { x: 0, y: 0, z: 0, ease: "elastic.in(1, 0.3)" };
        this.bVisible = bIn;
        let ctn = 0;
        this.killTweens();
        if (bIn) {
            this.navIcons.forEach(obj => {
                ctn++;
                small = { x: 0, y: 0, z: 0, ease: 'expo.in' };
                const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, delay: (.5 + .25 * ctn), ease: "elastic.out(1, 0.3)" };
                this.tweens.push(TweenMax.fromTo(obj.scale, 1, small, big));
            });
            ctn = 0;
            this.clickables.forEach(obj => {
                ctn++;
                // small = { x: 0, y: 0, z: 0, ease: 'expo.in' };
                const big: any = { x: 1, y: 1, z: 1, delay: (.5 + .25 * ctn), ease: "elastic.out(1, 0.3)" };
                this.tweens.push(TweenMax.fromTo(obj.scale, 1, small, big));
            });
            setTimeout(() => {
                this.rotate();
            }, 500);
        } else {
            this.navIcons.forEach(obj => {
                this.tweens.push(TweenMax.to(obj.scale, 1, small));
            });
            this.clickables.forEach(obj => {
                this.tweens.push(TweenMax.to(obj.scale, 1, small));
            });
        }
    }
    public rotate(): void {
        if (!this.bVisible) {
            return;
        }
        let ctn = 0;
        this.navIcons.forEach(obj => {
            ctn++;
            const rotate: any = { delay: .1 * ctn, y: 2 * Math.PI, ease: "none", onComplete: this.rotateComplete.bind(this), onCompleteParams: [obj] };
            // const rotate: any = { delay: .1 * ctn, y: 2 * Math.PI, repeat: -1, ease: "none", onComplete:this.rotateComplete };

            this.tweens.push(TweenMax.to(obj.rotation, 3, rotate));
        });
    }
    public rotateComplete(obj): void {
        if (!this.bVisible) {
            return;
        }
        const rotate: any = { y: 2 * Math.PI, ease: "none", onComplete: this.rotateComplete.bind(this), onCompleteParams: [obj] };
        this.tweens.push(TweenMax.fromTo(obj.rotation, 3, { y: 0 }, rotate));
    }

    public killTweens() {
        while (this.tweens.length > 0) {
            let t = this.tweens.pop();
            t.kill();
        }
    }


    public createIcons(iconFBX: FBX, centerPoint: Vector3): void {
        // console.log("createIcons", iconFBX, this._parent);

        const baseModelOffset: Vector3 = new Vector3(0, 0, 0)
        this.myBooth = boothData.booths.find(b => b.id === this._fbx.id);
        // console.log('this.myBooth', this.myBooth)
        let ctn = 0;
        this.myBooth.hotspots.forEach(spot => {
            ctn++;
            const newObj = iconFBX.fbx.clone();
            newObj.name = spot.modal + '|' + spot.isi_expanded + '|' + spot.text + (spot.alt_text ? '|' + spot.alt_text : '');
            newObj.position.y = spot.coords.y + baseModelOffset.y;
            newObj.position.z = spot.coords.z + baseModelOffset.z;
            newObj.position.x = spot.coords.x + baseModelOffset.x;
            newObj.scale.set(this.scale.x, this.scale.y, this.scale.z);
            newObj.castShadow = false;
            newObj.receiveShadow = false;

            this._parent.add(newObj);
            this.navIcons.push(newObj);

            // const geometry = new THREE.CylinderGeometry(0, 10, 30, 4, 1);
            const mGroup = new THREE.Group();
            // const geometry = new THREE.PlaneGeometry(60, 60, 32);
            const geometry = new THREE.CircleGeometry(35, 32);
            const material = new THREE.MeshPhongMaterial({
                color: 0xff0000, side: THREE.DoubleSide,
                opacity: 0,
                transparent: true,
            });
            const mesh = new THREE.Mesh(geometry, material);

            mGroup.position.y = spot.coords.y + baseModelOffset.y;
            mGroup.position.z = spot.coords.z + baseModelOffset.z;
            mGroup.position.x = spot.coords.x + baseModelOffset.x;

            mGroup.name = spot.modal + '|' + spot.isi_expanded + '|' + spot.text + (spot.alt_text ? '|' + spot.alt_text : '');
            mesh.name = "Bigger_Icon";

            mGroup.add(mesh)
            this._parent.add(mGroup);
            mGroup.lookAt(this.stateSvc.CENTER_POINT);
            this.clickables.push(mesh);
        });

    }

    public createBlur(): void {
        const self = this;
        this._fbx.fbx.traverse(function (child: any) {
            if (child.isMesh) {
                if (child.material) {

                    if (child.name === self._fbx.mainDisplayName) {
                        self.mainDisplayMesh = child;
                        self.normalMat = child.material.map;
                        console.log('CREATE BLUR, ', child)
                    }
                }

            }
        });

        this.blurMat = new THREE.MeshPhongMaterial({ map: null, side: THREE.DoubleSide });
        this.blurMat.map = new THREE.TextureLoader().load('assets/models/textures/' + this._fbx.blurryTexture, () => {
            console.log("Blur Image has been loaded.");
            this.blurLoaded = true;
        }
        );
    }

    public showBlurry(): void {
        console.log('showBlurry', this._fbx.name);
        if (this._fbx?.blurryTexture && this.blurLoaded) {
            this.mainDisplayMesh.material.map = this.blurMat.map;
        }
    }
    public hideBlurry(): void {
        console.log('hideBlurry', this._fbx.name)
        if (this._fbx?.blurryTexture && this.blurLoaded) {
            this.mainDisplayMesh.material.map = this.normalMat;
        }

    }
    public faceCamera(camera: any): void {
        this.clickables.forEach(plane => {
            plane.quaternion.copy(camera.quaternion);
        });

    }
    public get position(): Vector3 {
        return this._fbx.fbx.position;
    }
    public set position(pos: Vector3) {
        this._fbx.fbx.position = pos;
    }

    public get rotation(): Vector3 {
        return this._fbx.fbx.rotation;
    }
    public set rotation(rot: Vector3) {
        this._fbx.fbx.rotation = rot;
    }
}
